function initMCSSlider() {
  const sliderEl = document.querySelector('.M-mcs-Swiper');

  if (!sliderEl) return;

  // Prevent duplicate initialization
  if (sliderEl.swiper) {
    sliderEl.swiper.destroy(true, true);
  }

  sliderEl.classList.remove('preview');

  const swiper = new Swiper('.M-mcs-Swiper', {
    speed: 300,
    loop: true,
    centeredSlides: true,

    navigation: {
      nextEl: '.m-mcs-prev',
      prevEl: '.m-mcs-next',
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 15,
      },

      750: {
        slidesPerView: 3,
        spaceBetween: 20,
      },

      950: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });

  // Example slide change event
  swiper.on('slideChange', function () {
    console.log('Active slide:', swiper.realIndex);
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', initMCSSlider);

// Shopify Theme Editor support
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initMCSSlider);
  document.addEventListener('shopify:section:unload', function () {
    const sliderEl = document.querySelector('.M-mcs-Swiper');

    if (sliderEl && sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }
  });
}